import React from "react";
import { Navigate } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAdminAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg)] text-[#c9a86a]">
        <div className="animate-pulse tracking-[0.3em] text-sm">LE COLLECTIF HORLOGER</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
